import cn from 'clsx'
import { FC } from 'react'
import { connectSortBy } from 'react-instantsearch-dom'

interface sortByProps {
  items: any[]
  refine: any
}

const SortBy: FC<sortByProps> = ({ items, refine }) => {
  return (
    <>
      {items.map((item) => (
        <div
          key={item.value}
          className={cn(
            'ais-RefinementList-item w-full mb-2 lg:mb-4 cursor-pointer',
            {
              'ais-RefinementList-item--selected ': item.isRefined,
            }
          )}
          onClick={(event) => {
            event.preventDefault()
            refine(item.value)
          }}
        >
          <div className="flex items-center justify-center bg-ui-lightest-grey h-10 px-4 rounded text-body2 ">
            {item.label}
          </div>
        </div>
      ))}
    </>
  )
}

const CustomSortBy = connectSortBy(SortBy)

export default CustomSortBy
